if (!customElements.get('checkout-button')) {
  customElements.define(
    'checkout-button',
    class Button extends HTMLElement {
      constructor() {
        super();
        this.config = {
          dom: {
            button: '.js-checkout-button',
            link: '.js-checkout-link'
          },
          cls: {
            hidden: 'visually-hidden'
          }
        };
        this.buttonType = this?.dataset?.type || 'apple_pay';
        this.init();
      }
      init() {
        if (this?.buttonType === 'apple_pay') {
          if (window?.ApplePaySession) {
            this.showButton();
          }
        } else {
          this.showButton();
        }
      }
      showButton() {
       this.classList.remove(this.config.cls.hidden);
      }
    }
  );
}
